// Total Emission Volume
import { zipWith } from 'lodash';
import { createSelector } from 'reselect';

import {
  getElectricEmissionsPerKm,
} from './carbonEmissionRate';

import {
  getElectricDistanceTraveled,
} from '../vehicleDistanceTraveled/byFuel';

import {
  getCNGEmissionsTotal,
  getDieselEmissionsTotal,
  getGasolineEmissionsTotal
} from './ice';

export const getElectricEmissionsTotal = createSelector([
  getElectricEmissionsPerKm,
  getElectricDistanceTraveled
],
  (emissionsSeries, distanceSeries) => {

    const scaleFactor = .001; // Ensure final units are in (Mtons CO2) == 10^9/1000 / 1000/10^6

    return zipWith(
      emissionsSeries,
      distanceSeries,
      (emissions, distance) => {
        return {
          autoRickshaw: {
            commercial: emissions.autoRickshaw.commercial * distance.autoRickshaw.commercial * scaleFactor,
          },
          car: {
            commercial: emissions.car.commercial * distance.car.commercial * scaleFactor,
            private: emissions.car.private * distance.car.private * scaleFactor,

          },
          publicTransit: {
            bus: emissions.publicTransit.bus * distance.publicTransit.bus * scaleFactor,
            metro: emissions.publicTransit.metro * distance.publicTransit.metro * scaleFactor,
          },
          twoWheel: {
            commercial: emissions.twoWheel.commercial * distance.twoWheel.commercial * scaleFactor,
            private: emissions.twoWheel.private * distance.twoWheel.private * scaleFactor,
          }
        }
      }
    )
  }
)

export const getICEEmissionsTotal = createSelector([
  getGasolineEmissionsTotal,
  getDieselEmissionsTotal,
  getCNGEmissionsTotal
],
  (gasolineSeries,dieselSeries,CNGSeries) => {

    const scaleFactor = .001; // Ensure final units are in (Mtons CO2) == 10^9/1000 / 1000/10^6

    return zipWith(
      gasolineSeries,
      dieselSeries,
      CNGSeries,
        (gasoline, diesel, CNG) => {
        return {
          autoRickshaw: {
            commercial: (gasoline.autoRickshaw.commercial + diesel.autoRickshaw.commercial + CNG.autoRickshaw.commercial) * scaleFactor,
          },
          car: {
            commercial: (gasoline.car.commercial + diesel.car.commercial + CNG.car.commercial )* scaleFactor,
            private: (gasoline.car.private + diesel.car.private + CNG.car.private) * scaleFactor,

          },
          publicTransit: {
            bus: (gasoline.publicTransit.bus + diesel.publicTransit.bus + CNG.publicTransit.bus) * scaleFactor,
            // metro is electric only
          },
          twoWheel: { // only one fuel type
            commercial: gasoline.twoWheel.commercial * scaleFactor,
            private: gasoline.twoWheel.private * scaleFactor,
          }
        }
      }
    )
  }
)

// Combine ICE and Electric Subtotals
export const getCarbonEmissionsSeries = createSelector([
  getElectricEmissionsTotal,
  getICEEmissionsTotal,
],
  (electricSeries, iceSeries) => {

    return zipWith(
      electricSeries,
      iceSeries,
      (electric, ice) => {
        return {
          autoRickshaw: {
            commercial: electric.autoRickshaw.commercial + ice.autoRickshaw.commercial,
          },
          car: {
            commercial: electric.car.commercial + ice.car.commercial,
            private: electric.car.private + ice.car.private,

          },
          publicTransit: {
            bus: electric.publicTransit.bus + ice.publicTransit.bus,
            metro: electric.publicTransit.metro,
          },
          twoWheel: {
            commercial: electric.twoWheel.commercial + ice.twoWheel.commercial,
            private: electric.twoWheel.private + ice.twoWheel.private,
          }
        }
      }
    )
  }
)

// Can't use IOwnershipMode because car.public is not included
const getTotalFromCarbonMapping = (entry: any) => {
  return (
    entry.autoRickshaw.commercial +
    entry.car.commercial +
    entry.car.private +
    entry.twoWheel.commercial +
    entry.twoWheel.private +
    entry.publicTransit.bus +
    entry.publicTransit.metro
  )
}

export const getCarbonEmissionsTotalSeries = createSelector([
  getCarbonEmissionsSeries
],
  (carbonEmissionsSeries) => {
    return carbonEmissionsSeries.map(getTotalFromCarbonMapping);
  }
)

// For single number display
export const getCarbonEmissionsTotal = createSelector([
  getCarbonEmissionsTotalSeries
],
  (carbonEmissionsSeries): number => {
    return  carbonEmissionsSeries.slice(-1)[0];
  }
)



// WEBPACK FOOTER //
// ./src/store/selectors/carbonPollution/index.ts